import React from 'react';
import './DeleteConfirmationModal.css';
import { X, Trash2, AlertTriangle } from 'lucide-react';

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-container">
        <div className="delete-modal-header">
          <div className="header-title">
            <AlertTriangle className="warning-icon" size={20} />
            <h2>{title}</h2>
          </div>
          <button className="delete-modal-close" onClick={onClose} disabled={isLoading}>
            <X size={20} />
          </button>
        </div>

        <div className="delete-modal-content">
          <p>{message}</p>
        </div>

        <div className="delete-modal-footer">
          <button
            className="delete-modal-cancel-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="delete-modal-confirm-btn"
            onClick={onConfirm}
            disabled={isLoading}
          >
            <Trash2 size={16} className="trash-icon" />
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
